export const formFields = {
    signIn: {
        username: {
            label: 'Email',
            isRequired: true,
            placeholder: '',
        },
        password: {
            label: 'Password',
            isRequired: true,
        },
    },

    forceNewPassword: {
        password: {
            placeholder: 'Enter New Password',
        },
    },
    resetPassword: {
        username: {
            label: 'Email',
            placeholder: 'Enter your email',
        },
    },
};

export default formFields;
